export const edit_audio_view = (audioID) => ({
    init() {

    },

    async updateAudio($event) {
        const { isConfirmed } = await Swal.fire({
            title: 'Actualizar Audio',
            text: '¿Desea continuar con la actualización del registro?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Guardar',
            cancelButtonText: 'Cancelar'
        });

        if (!isConfirmed) return;

        const formData = new FormData($event.target);
        try {
            const { data } = await axios.post(`/api/audios/${audioID}`, formData);

            this.$dispatch('add-toast', {
                type: 'success',
                title: 'Audio Actualizado',
                text: `Se ha actualizado el audio <strong>${data.name}</strong>`
            });

            window.location.href = `/catalogos/audio-marca`;
        } catch (error) {
            this.$dispatch('add-toast', {
                type: 'error',
                title: 'Fallo al guardar audio',
                text: 'Unespected error. See console for more details.'
            });
            console.error('Error al crear audio', error);
            return;
        }
    }
});
